import { type MailboxInfo } from "owa-client-types";
import { isSuccessStatusCode } from "owa-http-status-codes";
import { makeGetRequest } from "owa-ows-gateway";

const AD_GETANID_ENDPOINT = "ows/beta/AdsIdServices/GetAnid";

/**
 * Resolves the anonymized identifier (ANID) for the OWA-authenticated account. The ANID is sent to
 * the Rewards flyout so it can verify the OWA account matches the Bing session server-side.
 *
 * @param mailboxInfo The OWA account whose ANID should be resolved.
 * @returns The ANID string, or `''` when it cannot be resolved.
 */
export default async function getRewardsExpectedAnid(mailboxInfo: MailboxInfo): Promise<string> {
    try {
        const response = await makeGetRequest(AD_GETANID_ENDPOINT, undefined, true, undefined, undefined, undefined, "getRewardsExpectedAnid", mailboxInfo);
        
        if (!isSuccessStatusCode(response.status)) {
            return "";
        }
        
        const anid = await response.text();
        return anid || "";
    }
    catch {
        // Network/service failure: treat the ANID as unresolved so the caller fails safe (the flyout
        // server treats a missing owaAnid as a mismatch and shows the error screen).
        return "";
    }
}
